/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UsdcPurchaseSellerNotificationActionData } from './UsdcPurchaseSellerNotificationActionData';
import {
    UsdcPurchaseSellerNotificationActionDataFromJSON,
    UsdcPurchaseSellerNotificationActionDataFromJSONTyped,
    UsdcPurchaseSellerNotificationActionDataToJSON,
} from './UsdcPurchaseSellerNotificationActionData';

/**
 * 
 * @export
 * @interface UsdcPurchaseSellerNotificationAction
 */
export interface UsdcPurchaseSellerNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof UsdcPurchaseSellerNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof UsdcPurchaseSellerNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof UsdcPurchaseSellerNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {UsdcPurchaseSellerNotificationActionData}
     * @memberof UsdcPurchaseSellerNotificationAction
     */
    data: UsdcPurchaseSellerNotificationActionData;
}

/**
 * Check if a given object implements the UsdcPurchaseSellerNotificationAction interface.
 */
export function instanceOfUsdcPurchaseSellerNotificationAction(value: object): value is UsdcPurchaseSellerNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function UsdcPurchaseSellerNotificationActionFromJSON(json: any): UsdcPurchaseSellerNotificationAction {
    return UsdcPurchaseSellerNotificationActionFromJSONTyped(json, false);
}

export function UsdcPurchaseSellerNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsdcPurchaseSellerNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': UsdcPurchaseSellerNotificationActionDataFromJSON(json['data']),
    };
}

export function UsdcPurchaseSellerNotificationActionToJSON(value?: UsdcPurchaseSellerNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': UsdcPurchaseSellerNotificationActionDataToJSON(value.data),
    };
}

